import { fun_PostAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 默认打开项目负责人异动管理
      activeName: "1",
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [
        {
          name: "同意异动",
          type: "success",
          icon: "document-add"
        },
        {
          name: "不同意异动",
          type: "danger",
          icon: "delete"
        }
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        personBasicinfoName: null, // 项目负责人名称
        corpName: null, // 现所在企业名称
        oldCorpName: null, // 原所在企业名称
        personModifyMark: null, // 人员信息变更记录
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目负责人姓名：",
          value: "personBasicinfoName",
          placeholder: "请输入",
          clearable: true
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目负责人姓名",
          prop: "personBasicinfoName",
        },
        {
          label: "证件类型",
          prop: "idCardTypeNum",
        },
        {
          label: "证件号码",
          prop: "idCard",
        },
        {
          label: "异动内容",
          prop: "personModifyMark",
        },
      ],
      // 表格数据
      tableData: [],
      userFlag: sessionStorage.getItem("userFlag"), // 用户标识
      userType: sessionStorage.getItem("userType"), // 用户类型
      multipleSelection: [], // 勾选数组
    };
  },
  // 注册组件
  components: {},

  // 模板编译完成
  mounted() {
    // 异动管理
    if (this.activeName === "1") {
      // 用户类型
      if (this.userType !== "201508061647340018") {
        // 清空表单查询
        this.formSearchList = [];
        // 设置表单
        this.tableColumns = [
          {
            label: "企业名称",
            prop: "existCorpName",
          },
          {
            label: "异动时间",
            prop: "insertDate",
          },
          {
            label: "异动内容",
            prop: "personModifyMark",
          },
        ];
      }
    }
    // 查询一览数据
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 切换tab方法
     * @author shuhu
     */
    handleClick(tab) {
      // 获取activeName
      this.activeName = tab;
      // 异动管理
      if (this.activeName === "1") {
        // 用户类型
        if (this.userType !== "201508061647340018") {
          // 清空表单查询
          this.formSearchList = [];
          // 设置表单
          this.tableColumns = [
            {
              label: "企业名称",
              prop: "existCorpName",
            },
            {
              label: "异动时间",
              prop: "insertDate",
            },
            {
              label: "异动内容",
              prop: "personModifyMark",
            },
          ];
        } else {
          // 查询参数
          this.formSearchList = [
            {
              type: "input",
              label: "项目负责人姓名：",
              value: "personBasicinfoName",
              placeholder: "请输入",
              clearable: true
            },
          ];
          // 显示列
          this.tableColumns = [
            {
              label: "项目负责人姓名",
              prop: "personBasicinfoName",
              isShow: true,
            },
            {
              label: "证件类型",
              prop: "idCardTypeNum",
            },
            {
              label: "证件号码",
              prop: "idCard",
            },
            {
              label: "异动内容",
              prop: "personModifyMark",
            },
          ];
        }
        // 获取异动管理一览
        this.fun_GetList();
      } else {
        // 添加查询参数
        this.formSearchList.push(
          {
            type: "input",
            label: "现所在企业名称：",
            value: "corpName",
            placeholder: "请输入",
            clearable: true
          },
          {
            type: "input",
            label: "原所在企业名称：",
            value: "oldCorpName",
            placeholder: "请输入",
            clearable: true
          },
          {
            type: "input",
            label: "人员信息变更记录：",
            value: "personModifyMark",
            placeholder: "请输入",
            clearable: true
          }
        );
        // 显示列
        this.tableColumns = [
          {
            label: "项目负责人姓名",
            prop: "personBasicinfoName",
            width: 150,
            fixed: true,
          },
          {
            label: "证件类型",
            prop: "idCardTypeNum",
            width: 150
          },
          {
            label: "证件号码",
            prop: "idCard",
            width: 180
          },
          {
            label: "注册人员状态",
            prop: "personStateName",
            width: 180
          },
          {
            label: "确认是否转出时间",
            prop: "insertDate",
            width: 180
          },
          {
            label: "异动撤回",
            slotName: "operation",
            width: 100
          },
          {
            label: "现所在企业名称",
            prop: "corpName",
            width: 200
          },
          {
            label: "现所在企业状态",
            prop: "corpStateName",
            width: 180
          },
          {
            label: "确认是否转入时间",
            prop: "updateDate",
            width: 180
          },
          {
            label: "原所在企业名称",
            prop: "oldCorpName",
            width: 200
          },
          {
            label: "原所在企业状态",
            prop: "oldcorpStateName",
            width: 180
          },
          {
            label: "异动记录",
            prop: "personModifyMark",
            width: 200
          },
        ];
        // 获取异动记录一览
        this.fun_GetRecordList();
      }
    },

    /**
     * 获取一览表格数据
     * @author 付翔
     */
    fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        fun_PostAction("/regPersonModifyinfo/list", {
          ...this.form,
          ...this.reqPageData
        }).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 判断请求是否成功
          if (result) {
            // 解构data
            const { total, records } = data;
            // 回显table
            this.tableData = records;
            // 获取分页总条数
            this.total = total;
            // 关闭loading
            this.loading = false;
          } else {
            // 关闭loading
            this.loading = false;
            // 提示请求失败消息
            this.$message.error(msg);
          }
        });
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },

    /**
     * 获取异动记录一览
     */
    fun_GetRecordList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        fun_PostAction("/regPersonModifyinfo/logList", {
          ...this.form,
          ...this.reqPageData
        }).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 判断请求是否成功
          if (result) {
            // 解构data
            const { total, records } = data;
            // 回显table
            this.tableData = records;
            // 遍历返回数据
            for (const index in this.tableData) {
              // 确认是否转出时间
              let insertDate = '';
              // 确认转入时间
              let updateDate = '';
              // 如果原企业编号不为空
              if (this.tableData[index].oldCorpId != '' && this.tableData[index].oldCorpId != null) {
                // 如果项目负责人状态不为空并且原企业状态也不为空
                if (this.tableData[index].personState != '' && this.tableData[index].personState != null && this.tableData[index].oldCorpState != '' && this.tableData[index].oldCorpState != null) {
                  // 如果项目负责人状态为同意异动或者原企业状态为同意异动
                  if (this.tableData[index].personState == '1' && this.tableData[index].oldCorpState == '1') {
                    // 设置确认是否转出时间
                    insertDate = this.tableData[index].insertDate;
                  } else {
                    // 设置确认是否转出时间
                    insertDate = this.tableData[index].updateDate;
                  }
                } else {
                  // 设置确认是否转出时间
                  insertDate = this.tableData[index].insertDate;
                }
              }
              // 如果原企业编号为空
              if (this.tableData[index].oldCorpId == '' || this.tableData[index].oldCorpId == null) {
                // 如果项目负责人状态不为空并且现企业状态也不为空
                if (this.tableData[index].personState != '' && this.tableData[index].personState != null && this.tableData[index].corpState != '' && this.tableData[index].corpState != null) {
                  // 设置确认是否转入时间
                  updateDate = this.tableData[index].updateDate;
                } else {
                  // 设置确认是否转入时间
                  updateDate = this.tableData[index].insertDate;
                }
              }
              // 如果项目负责人状态为同意异动或者原企业状态为同意异动
              else if (this.tableData[index].personState == '1' && this.tableData[index].oldCorpState == '1') {
                // 如果现企业编号为空
                if (this.tableData[index].corpId == '' || this.tableData[index].corpId == null) {
                  // 设置确认是否转入时间
                  updateDate = '';
                } else {
                  // 设置确认是否转入时间
                  updateDate = this.tableData[index].updateDate;
                }
              }
              // 重新设置确认是否转出时间
              this.tableData[index].insertDate = insertDate;
              // 重新设置确认是否转入时间
              this.tableData[index].updateDate = updateDate;
            }
            // 获取分页总条数
            this.total = total;
            // 关闭loading
            this.loading = false;
          } else {
            // 关闭loading
            this.loading = false;
            // 提示请求失败消息
            this.$message.error(msg);
          }
        })
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },

    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      if (this.activeName === "1") {
        // 异动管理一览
        this.fun_GetList();
      } else {
        // 异动记录一览
        this.fun_GetRecordList();
      }
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      if (this.activeName === "1") {
        // 异动管理一览
        this.fun_GetList();
      } else {
        // 异动记录一览
        this.fun_GetRecordList();
      }
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      if (this.activeName === "1") {
        // 异动管理一览
        this.fun_GetList();
      } else {
        // 异动记录一览
        this.fun_GetRecordList();
      }
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      if (this.activeName === "1") {
        // 异动管理一览
        this.fun_GetList();
      } else {
        // 异动记录一览
        this.fun_GetRecordList();
      }
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_click(e) {
      switch (e) {
        case "同意异动":
          this.fun_RegPersonModify('1');
          break;
        case "不同意异动":
          this.fun_RegPersonModify('2');
          break;
        default:
      }
    },

    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },

    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_Details(e) {
      // 子传父
      this.$emit("fun_Details", "regPersonBasicinfoDetails", { id: e.val.personBasicinfoId, type: "details" });
    },

    /**
     * 人员异动
     */
    fun_RegPersonModify(e) {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 主键集合
        let keys = [];
        // 遍历勾选
        for (const index in this.multipleSelection) {
          // 赋值主键集合
          keys[index] = this.multipleSelection[index].id;
        }
        // 弹出询问confirm
        this.$confirm("是否确定进行该操作？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 请求，获取结果集
          fun_PostAction("/regPersonModifyinfo/regPersonModify", {
            keys: keys,
            flag: e, // 异动状态
          }).then(res => {
            // 解构res.data
            const { msg } = res.data;
            this.$alert(msg);
            // 查询一览数据
            this.fun_GetList();
          });
        });
      } else {
        this.$alert("请至少选中一行数据！", "warning");
        return;
      }
    },

    /**
     * 异动撤回
     * @param e
     */
    fun_RevokeInfo(e) {
      // 弹出询问confirm
      this.$confirm("确认要撤回此项目负责人异动？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 请求，获取结果集
        fun_PostAction("/regPersonModifyinfo/revokeInfo", {
          id: e.id,
        }).then(res => {
          // 解构res.data
          const { msg } = res.data;
          // 提示，并清除选中数据
          this.$alert(msg, "warning").then(() => {
            // 获取一览表格数据
            this.fun_GetRecordList();
          });
        });
      });
    },
  }
};
